



























    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import Quagga from 'quagga'; // ES6
    import shipmentList from '@/store/entities/back-logistics-list'
    import appconst from '@/lib/appconst';
    class TakePictureInput {
        id: number;
        imageGuid: string;
        goodsImageGuid: string;
    }
    @Component({
        name: "expressphoto",
    })
    export default class ExpressPhoto extends AbpBase {
        selectShipmentList: shipmentList = new shipmentList();
        logistics: Array<shipmentList> = [];
        processTakePictureInput: TakePictureInput = new TakePictureInput();
        imageGuidUrl: string = '';
        goodsImageGuidUrl: string = '';
        selectNumber?: number = null;


        async takeImageGuidPhoto(e) {//拍照功能---上传头像
            var file = e.target.files[0]//获取文件对象
            var fd = new FormData();//构造formdata对象
            fd.append('file', file) //向formdata里面存放键值对
            this.processTakePictureInput.imageGuid = await this.$store.dispatch({
                type: 'backlogistics/uploadLogisticsImg',
                data: fd
            });
            var data = { imageGuid: this.processTakePictureInput.imageGuid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            this.imageGuidUrl = data.url;
        }

        async takeGoodsImageGuidPhoto(e) {//拍照功能---上传头像
            var file = e.target.files[0]//获取文件对象
            var fd = new FormData();//构造formdata对象
            fd.append('file', file) //向formdata里面存放键值对
            this.processTakePictureInput.goodsImageGuid = await this.$store.dispatch({
                type: 'backlogistics/uploadLogisticsImg',
                data: fd
            });

            var datas = { goodsImageGuid: this.processTakePictureInput.goodsImageGuid, urls: null };
            this.$store.commit('backlogistics/getGoodsImgUrl', datas);
            this.goodsImageGuidUrl = datas.urls;
        }



        changeShipment(val: number) {
            var data = this.logistics.filter(function (item) { return item.id == val })[0];
            this.selectShipmentList.shelfNumber = data.shelfNumber;
            // this.selectShipmentList.id = data.id;
            this.selectShipmentList.shipment = data.shipment;
            this.processTakePictureInput.id = data.id;
            this.processTakePictureInput.imageGuid = '';
            this.processTakePictureInput.goodsImageGuid = '';
            this.goodsImageGuidUrl = "";
            this.imageGuidUrl = "";
        }
        async get() {
            this.logistics = await this.$store.dispatch({
                type: 'backlogistics/getNeedTakePictureList',
                data: {}
            });
            if (this.logistics.length > 0) {
                this.selectNumber = this.logistics[0].id;
                this.changeShipment(this.selectNumber);
            }

        }
        async save() {
            await this.$store.dispatch({
                type: 'backlogistics/setTakePicture',
                data: this.processTakePictureInput
            })
            this.$Message.success('保存成功');
            location.reload();
        }
        created() {
            this.get();

            if (abp.isMobile()) {
                abp.hideMenu();
            }
        }
    };
